module.exports = __webpack_public_path__ + "static/logo-b044e938806d141358cff8e5b29a49b7.png";